(function() {
    'use strict';

    angular
        .module('nasracApp')
        .directive('hasAnyAuthority', hasAnyAuthority);

    hasAnyAuthority.$inject = ['Principal'];

    function hasAnyAuthority(Principal) {
        var directive = {
            restrict: 'A',
            link: linkFunc
        };

        return directive;

        function linkFunc(scope, element, attrs) {

            var authorities = attrs.hasAnyAuthority.split(',');

            var setVisible = function () {
                    element.removeClass('hidden');
                },
                setHidden = function () {
                    element.addClass('hidden');
                },
                defineVisibility = function (reset) {
                    var result;
                    if (reset) {
                        setVisible();
                    }
                    var updFlag = Principal.currentIdentity.userPasswordUpdFlag;
                    result = Principal.hasAnyAuthority(authorities);
                    if (result) {
                        //Do not display any other tab to user if UPD flag is true. Force User to change password.
                        if(updFlag){
                            setHidden();
                        }else{
                            setVisible();
                        }
                    } else {
                        setHidden();
                    }
                };

            if (authorities.length > 0) {
                defineVisibility(true);

                scope.$watch(function() {
                    return Principal.isAuthenticated();
                }, function() {
                    defineVisibility(true);
                });
            }
        }
    }
})();
